const defaultCountries: { [locale: string]: string } = {
	"fr-BE": "FR",
	"fr-FR": "FR",
	"fr-FR-CSE": "FR",
	"en-US": "GB",
	"nl-NL": "NL",
}

export default defaultCountries
